import type { Credential } from '@/features/signin/domains/credential'
import type { CredentialEntity } from '../entity/credential_entity'

export class CrendentialMapper {
  public static toEntity(payload: Credential): CredentialEntity {
    return {
      cedula: payload.user,
      password: payload.password,
    }
  }
}
